import React, { FC } from 'react';
import * as S from './Rankings.style';

interface IProps {
  rankings: {
    totalPoints: number;
    player: string;
    scores: Array<number | undefined>;
  }[];
  isDarts: boolean;
}

export const Rankings: FC<IProps> = ({ rankings = [], isDarts }) => {
  const sortedRankings = [...rankings].sort((a, b) => {
    return isDarts
      ? a.totalPoints - b.totalPoints // lowest first (Darts)
      : b.totalPoints - a.totalPoints; // highest first (Sum of Points)
  });

  return sortedRankings.length ? (
    <S.Container>
      <h2>Leaderboard</h2>
      <S.Rankings>
        {sortedRankings.map(({ player, totalPoints }, index) => (
          <li key={player}>
            <div>0{index + 1}</div>
            <div>{player}</div>
            {isDarts ? (
              <div />
            ) : (
              <div>
                <S.Points>{totalPoints} pt</S.Points>
              </div>
            )}
          </li>
        ))}
      </S.Rankings>
    </S.Container>
  ) : null;
};
